import { render } from "./MinBarChart.vue?vue&type=template&id=10f8d157&scoped=true"
import script from "./MinBarChart.vue?vue&type=script&lang=js"
export * from "./MinBarChart.vue?vue&type=script&lang=js"

import "./MinBarChart.vue?vue&type=style&index=0&id=10f8d157&scoped=true&lang=css"

import exportComponent from "/home/misha/Рабочий стол/standart-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10f8d157"]])

export default __exports__